import React from 'react';
import { FormattedMessage } from 'react-intl';

import EntityTable from '../entity/entityTable';
import AssignTable from './assignTable';

const AssignMainComponent = props => {  
  const {
    entityTableDescriptor,
    entityData,
    assignData,
    topControlsFormDataEntity,
    topControlsFormDataAssign,
    fetchOrderListEntity,
    fetchListChangePageEntity,
    handleOnChangeTopControlsEntity,
    handleRowClickEntity,
    handleOnChangeSearchAssign,
    fetchListChangePageAssign,
    handleCheckBoxClickAssign,
    saveAssignData,
    parentTitle,
    assignsTitle,
    noAssignText,
    assignTypeLabel
  } = props;
  return (
    <div className="assign_row">
      <div className="assign_table">
        <div className="assign_table_title">
          {parentTitle}
        </div>
        <EntityTable
          entityTableDescriptor={entityTableDescriptor}
          data={entityData.data}
          selectedId={assignData.assignId}
          loading={entityData.loading}
          page={entityData.page}
          totalPages={entityData.totalPages}
          totalRecords={entityData.totalRecords}
          orderBy={entityData.orderBy}
          orderByDirection={entityData.orderByDirection}
          topControlsFormData={topControlsFormDataEntity}
          handleOnChangeTopControls={handleOnChangeTopControlsEntity}
          fetchOrderList={fetchOrderListEntity}
          fetchListChangePage={fetchListChangePageEntity}
          hideActions={true}
          handleRowClick={handleRowClickEntity}
          className="assign_table_component"
        />
      </div>
      <div className="assign_table">
        <div className="assign_table_title">
          {assignsTitle}
          <span>{assignData.assignName}</span>
          <span className="assign_table_asociateds">
            <FormattedMessage id="common.assign.associateds"/>
            {": " + (assignData.paginationStatus ? assignData.paginationStatus.total_associated_records : "")}
            {(assignData.paginationStatus && "total_direct_associated_records" in assignData.paginationStatus) && (
              <span>{" ("}<FormattedMessage id="common.assign.direct"/>{" " + assignData.paginationStatus.total_direct_associated_records + ")"}</span>
            )}
          </span>
        </div>
        <AssignTable
          nameProperty="name"
          assignTypeLabel={assignTypeLabel}
          assignId={assignData.assignId}
          noAssignText={noAssignText}
          data={assignData.data}
          loading={assignData.loading}
          page={assignData.page}
          totalPages={assignData.totalPages}
          totalRecords={assignData.totalRecords}
          searchText={topControlsFormDataAssign.assignSearchText}
          handleOnChangeSearch={handleOnChangeSearchAssign}
          fetchListChangePage={fetchListChangePageAssign}
          handleCheckBoxClick={handleCheckBoxClickAssign}
          saveAssignData={saveAssignData}
        />
      </div>
    </div>
  );
};

export default AssignMainComponent;



// WEBPACK FOOTER //
// ./source/client/components/common/assign/assignMainComponent.jsx